import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';

import { FiltersContext } from '../../filters/context';
import ToggleSidebarButton from '../../pages/orders-page/toggle-sidebar-button';
import FilterBar from '../../components/filter-bar';
import { FilterViewProps } from '../../store/orders/filtering/filterview.properties';
import { mapOrdersFilterBarFiltersToContext } from '../../filters/context/map-filter-bar-filters-to-context';

import { useOrdersFilterBarState, useOrdersFilterBarDispatch } from './hooks';
import { emptyArray } from 'ui-components/default-props/empty';

import style from './style.module.less';

export const filterBar = 'filterBar';

export const OrdersFilterBarContainer = ({ isInQuickSearch = false }) => {
  const {
    allFilterBys,
    appliedFilters,
    criteriaArgumentsMap,
    criteriaOperatorsMap,
    currentFilterView,
    implicitFilterByIds,
    otherFilterBys,
    popularFilterBys,
  } = useOrdersFilterBarState();
  const { autoSwitchFilterViewToCustom, autoSwitchFilterViewToDefault, changeCustomFilterViewProp, requestGetOrders, resetToPageOne } =
    useOrdersFilterBarDispatch();
  const { replaceFiltersForSource } = useContext(FiltersContext);

  const _onFiltersChanged = useCallback(
    (newlyAppliedFilters) => {
      const newFilters = mapOrdersFilterBarFiltersToContext(newlyAppliedFilters);

      resetToPageOne();
      if (newlyAppliedFilters.length === 0) {
        autoSwitchFilterViewToDefault();
        replaceFiltersForSource(filterBar);
        return;
      }

      replaceFiltersForSource(filterBar, newFilters);

      if (currentFilterView.filterViewId === 'custom') {
        changeCustomFilterViewProp(FilterViewProps.FILTERVIEW_FILTERS, newlyAppliedFilters);
        requestGetOrders(newlyAppliedFilters, currentFilterView.filterViewId);
        return;
      }

      autoSwitchFilterViewToCustom(newlyAppliedFilters, currentFilterView);
      requestGetOrders(newlyAppliedFilters, 'custom');
    },
    [
      autoSwitchFilterViewToCustom,
      autoSwitchFilterViewToDefault,
      resetToPageOne,
      changeCustomFilterViewProp,
      currentFilterView,
      replaceFiltersForSource,
      requestGetOrders,
    ],
  );

  const clearFilters = useCallback(() => {
    _onFiltersChanged(emptyArray);
  }, [_onFiltersChanged]);

  if (isInQuickSearch) {
    return (
      <div className={style['edit-columns-and-drawer']}>
        <ToggleSidebarButton />
      </div>
    );
  }

  return (
    <div className={style['filter-bar-wrapper']}>
      <FilterBar
        allFilterBys={allFilterBys}
        appliedFilters={appliedFilters}
        clearFilters={clearFilters}
        criteriaArgumentsMap={criteriaArgumentsMap}
        criteriaOperatorsMap={criteriaOperatorsMap}
        currentFilterView={currentFilterView}
        implicitFilterByIds={implicitFilterByIds}
        onFiltersChanged={_onFiltersChanged}
        otherFilterBys={otherFilterBys}
        popularFilterBys={popularFilterBys}
        saveFilterPath='/orders/'
      />
      <div className={style['filter-bar-actions-wrapper']}>
        <div className={style['sidebar-toggle']}>
          <ToggleSidebarButton />
        </div>
      </div>
    </div>
  );
};

OrdersFilterBarContainer.propTypes = {
  isInQuickSearch: PropTypes.bool,
};
